import React from "react";
import { Box, Flex, Text, Button, useDisclosure } from "@chakra-ui/react";
import { FiPlayCircle } from "react-icons/fi";
import ss from "../../assets/svg/ss.svg";
import Logo from "../../assets/svg/logo.svg";
import message from "../../assets/svg/message.svg";
import thunderbolt from "../../assets/svg/thunderbolt.svg";
import happyface from "../../assets/svg/happyface.svg";
import bar from "../../assets/svg/bar.svg";
import command from "../../assets/svg/command.svg";
import chart from "../../assets/svg/chart.svg";
import groupIcon from "../../assets/svg/groupIcon.svg";

import ExploreServices from "./ExploreServices";
import Review from "./Review";
import Faq from "./Faq";
import Footer from "./Footer";
import BookDemoModal from "components/Modal/BookDemoModal";
import ContactUsModal from "components/Modal/ContactUsModal";
import GetInTouchModal from "components/Modal/GetInTouchModal";

function LandingPage() {
  const {
    isOpen: isContactOpen,
    onOpen: openContact,
    onClose: closeContact,
  } = useDisclosure();
  const {
    isOpen: isDemoOpen,
    onOpen: openDemo,
    onClose: closeDemo,
  } = useDisclosure();

  const {
    isOpen: isGetInTouch,
    onOpen: openGetInTouch,
    onClose: closeGetInTouch,
  } = useDisclosure();


  const buttonStyle = {
    borderRadius: "8px",
    fontFamily: "Montserrat",
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "17.07px",
    padding: "16px 24px 16px 24px",

    background: `
      linear-gradient(62.63deg, #390EF7 13.23%, #9244F4 79.12%),
      linear-gradient(0deg, #FFFFFF, #FFFFFF)
    `,
    color: "rgba(255, 255, 255, 1)",
  };

  const bigTextStyle = {
    color: "rgba(29, 33, 48, 1)",
    fontFamily: "Roboto",
    fontWeight: "700",
    fontSize: "32px",
    lineHeight: "38.4px",
  };

  const smallTextStyle = {
    color: "rgba(102, 112, 133, 1)",
    fontFamily: "Roboto",
    fontWeight: "400",
    fontSize: "20px",
    lineHeight: "30px",
  };

  return (
    <Box position="relative" p="0" bg="rgba(255, 255, 255, 1)" w='100vw' overflow='hidden'>
      <Flex
        bg="linear-gradient(89.45deg, #390EF7 -19.13%, #9244F4 101.61%)" // Set the linear gradient here
        justify={{ base: 'space-evenly', md: 'center' }}

      >

      </Flex>
      <Flex padding="2rem" justifyContent="space-between" direction={{ base: 'column', sm: 'row' }}>
        <img style={{ cursor: "pointer" }} src={Logo} alt="" />

        <Button style={buttonStyle} w="144px" h="49px" onClick={openDemo}>
          Book a Demo
        </Button>
      </Flex>{" "}

      <Flex mt="5rem" direction="column" gap="1rem" align="center">
        <Flex
          gap="5px"
          fontFamily="Inter"
          fontSize="14px"
          fontWeight="500"
          lineHeight="20px"
          borderRadius="16px"
          padding="4px 10px 4px 10px"
          bg="rgba(249, 245, 255, 1)"
          align="center"
        >

        </Flex>
        <Flex
          textAlign="center"
          padding={'1rem'}
          direction="column"
          color="rgba(16, 24, 40, 1)"
          fontFamily="Inter"
          fontSize="60px"
          fontWeight="600"
          letterSpacing="-1.2px"
          lineHeight="72px"
        >
          <Text fontSize={{ base: "50px", md: "55px" }}>Unlock Messaging Potential with </Text>
          <Text fontSize={{ base: "50px", md: "55px" }}>SMS Flash</Text>
        </Flex>

        <Flex
          left="0"
          position="absolute"
          w="400px"
          h="400px"
          opacity="0.5"
          filter="blur(150px)"
          bg="radial-gradient(2762.36% 537.65% at -49.5% -250%, #D798E1 17.55%, #AED3FF 49.89%, #C9D4EF 56.53%, #CACFFA 65.69%)"
        ></Flex>
        <Flex
          right="0"
          position="absolute"
          w="400px"
          h="400px"
          opacity="0.5"
          filter="blur(150px)"
          bg="radial-gradient(2762.36% 537.65% at -49.5% -250%, #D798E1 17.55%, #AED3FF 49.89%, #C9D4EF 56.53%, #CACFFA 65.69%)"
        ></Flex>
      </Flex>
      <Flex
        textAlign="center"
        direction="column"
        color="rgba(102, 112, 133, 1)"
        fontFamily="Inter"
        fontSize="20px"
        fontWeight="400"
        lineHeight="30px"
      >
        <Text padding={'0.5rem'}>
          Elevate your A2P Messaging with SMS Flash, the cutting-edge SMPP
          Switch that offers Content-Based Routing,
        </Text>
        <Text>Bulk Scheduling, AI-Powered Security, and more.</Text>
      </Flex>
      <Flex gap="1rem" mt="2rem" align="center" justify="center">
        <Button
          fontFamily="Inter"
          fontWeight="600"
          fontSize="18px"
          lineHeight="28px"
          color="rgba(52, 64, 84, 1)"
          bg="rgba(255, 255, 255, 1)"
          border="1px solid rgba(208, 213, 221, 1)"
          borderRadius="8px"
          h="60px"
          w="143px"
          gap=".5rem"
        >
          <FiPlayCircle size="20px" />
          Demo
        </Button>
        <Button
          onClick={openContact}
          border="1px solid rgba(127, 86, 217, 1)"
          borderRadius="8px"
          fontFamily="Inter"
          fontSize="18px"
          fontWeight="600"
          lineHeight="28px"
          color="rgba(255, 255, 255, 1)"
          bg="linear-gradient(82.65deg, #390EF7 2.87%, #9244F4 97.54%)"
          w="154px"
          h="60px"
          _hover={{
            bg: "linear-gradient(82.65deg, #390EF7 2.87%, #9244F4 97.54%)",
          }}
        >
          Contact Us
        </Button>
        <ContactUsModal isOpen={isContactOpen} onClose={closeContact} />
      </Flex>
      <Flex mt="7rem" justifyContent="center">
        <Flex
          borderTop="10px solid black"
          borderLeft="10px solid black"
          borderRight="10px solid black"
          borderRadius="16px"
        >
          <img src={ss} alt="Application interface screenshot" />
        </Flex>
      </Flex>
      <Flex
        direction="column"
        bg="linear-gradient(265.57deg, #DBD3FF 0%, rgba(216, 227, 252, 0.41) 100%)"
        h="407px"
        align="center"
        justify="center"
        gap="1rem"
      >
        <Text
          bg="linear-gradient(59.45deg, #390EF7 13.91%, #9244F4 82.08%)"
          bgClip="text"
          fontFamily="Inter"
          fontWeight="600"
          fontSize="20px"
          lineHeight="28.8px"
        >
          About Us
        </Text>
        <Text
          color="rgba(29, 33, 48, 1)"
          fontFamily="Inter"
          fontWeight="600"
          fontSize="38px"
          lineHeight="45.6px"
        >
          Who We Are
        </Text>
        <Flex textAlign="center" direction="column">
          <Text
            color="rgba(102, 112, 133, 1)"
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            lineHeight="30px"
            padding={'0.25rem'}

          >
            We are a dedicated team of innovators, committed to enhancing your
            messaging
          </Text>
          <Text
            color="rgba(102, 112, 133, 1)"
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            lineHeight="30px"
            padding={'0.2rem'}
          >
            experience. Our mission is to provide reliable, secure, and
            feature-rich A2P messaging
          </Text>
          <Text
            color="rgba(102, 112, 133, 1)"
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="400"
            lineHeight="30px"

          >
            solutions through SMS Flash.
          </Text>
        </Flex>
      </Flex>
      <Flex mt="5rem" direction="column">
        <Flex
          gap="1rem"
          textAlign="center"
          justifyContent="center"
          direction="column"
        >
          <Text
            color="rgba(105, 65, 198, 1)"
            fontFamily="Inter"
            fontWeight="600"
            fontSize="24px"
            lineHeight="24px"
          >
            Features
          </Text>
          <Text
            color="rgba(16, 24, 40, 1)"
            fontFamily="Inter"
            fontSize="36px"
            fontWeight="600"
            lineHeight="44px"
            letterSpacing="-0.72px"
          >
            Analytics that feels like it’s from the future
          </Text>
          <Flex direction="column">
            <Text
              color="rgba(102, 112, 133, 1)"
              fontFamily="Inter"
              fontWeight="400"
              fontSize="20px"
              lineHeight="30px"
            >
              Powerful, self-serve product and growth analytics to help you
              convert, engage,
            </Text>
            <Text
              color="rgba(102, 112, 133, 1)"
              fontFamily="Inter"
              fontWeight="400"
              fontSize="20px"
              lineHeight="30px"
            >
              and retain more users. Trusted by over 4,000 startups.
            </Text>
          </Flex>
        </Flex>
        <Flex mt="5rem" gap="5rem" justifyContent={'center'} alignItems="center" direction={{ base: 'column', md: 'row' }} flexWrap='wrap'   >
          <Flex gap=".5rem" alignItems="center" direction="column" padding={'5px'}>
            <img src={message} alt="Content based routing icon" width="48px" height="48px" />
            <Text
              color="rgba(16, 24, 40, 1)"
              fontFamily="Inter"
              fontSize="20px"
              fontWeight="500"
              lineHeight="30px"
            >
              Content based routing
            </Text>
            <Flex
              color="rgba(102, 112, 133, 1)"
              fontFamily="Inter"
              fontWeight="400"
              fontSize="16px"
              lineHeight="24px"
              textAlign="center"
              direction="column"
            >
              <Text>Effortlessly route messages based on content</Text>
              <Text>for tailored messaging experiences</Text>
            </Flex>
          </Flex>
          <Flex gap=".5rem" alignItems="center" direction="column">
            <img src={thunderbolt} alt="Number specific routing icon" width="48px" height="48px" />
            <Text
              color="rgba(16, 24, 40, 1)"
              fontFamily="Inter"
              fontSize="20px"
              fontWeight="500"
              lineHeight="30px"
            >
              Number Specific Routing
            </Text>
            <Flex
              color="rgba(102, 112, 133, 1)"
              fontFamily="Inter"
              fontWeight="400"
              fontSize="16px"
              lineHeight="24px"
              textAlign="center"
              direction="column"
            >
              <Text>Optimize message delivery with precise</Text>
              <Text>routing based on recipient numbers</Text>
            </Flex>
          </Flex>
          <Flex gap=".5rem" alignItems="center" direction="column">
            <img src={bar} alt="Bulk message scheduling icon" width="48px" height="48px" />
            <Text
              color="rgba(16, 24, 40, 1)"
              fontFamily="Inter"
              fontSize="20px"
              fontWeight="500"
              lineHeight="30px"
            >
              Bulk Message Scheduling
            </Text>
            <Flex
              color="rgba(102, 112, 133, 1)"
              fontFamily="Inter"
              fontWeight="400"
              fontSize="16px"
              lineHeight="24px"
              textAlign="center"
              direction="column"
            >
              <Text>Plan and schedule large-scale messaging</Text>
              <Text>campaigns for maximum impact</Text>
            </Flex>
            {/* </Flex> */}
          </Flex>

          {/* <Flex gap="5rem" align="center" border='2px solid yellow'> */}
          <Flex gap=".5rem" alignItems="center" direction="column">
            <img src={happyface} alt="AI-powered firewall icon" width="48px" height="48px" />
            <Text
              color="rgba(16, 24, 40, 1)"
              fontFamily="Inter"
              fontSize="20px"
              fontWeight="500"
              lineHeight="30px"
            >
              AI-Powered Firewall
            </Text>
            <Flex
              color="rgba(102, 112, 133, 1)"
              fontFamily="Inter"
              fontWeight="400"
              fontSize="16px"
              lineHeight="24px"
              textAlign="center"
              direction="column"
            >
              <Text>Enhance security with our AI-driven firewall, </Text>
              <Text>ensuring safe messaging operations..</Text>
            </Flex>
          </Flex>
          <Flex gap=".5rem" alignItems="center" direction="column">
            <img src={command} alt="Smart invoice generation icon" width="48px" height="48px" />
            <Text
              color="rgba(16, 24, 40, 1)"
              fontFamily="Inter"
              fontSize="20px"
              fontWeight="500"
              lineHeight="30px"
            >
              Smart Invoice Generation
            </Text>
            <Flex
              color="rgba(102, 112, 133, 1)"
              fontFamily="Inter"
              fontWeight="400"
              fontSize="16px"
              lineHeight="24px"
              textAlign="center"
              direction="column"
            >
              <Text>Streamline your accounting with automated</Text>
              <Text>invoice generation and management</Text>
            </Flex>
          </Flex>
          {/* </Flex> */}
        </Flex>
        <Flex
          mt="5rem"
          direction={{ sm: 'row', md: 'row' }}
          justifyContent="space-evenly"

          h="563px"
          bg="linear-gradient(265.57deg, #DBD3FF 0%, rgba(216, 227, 252, 0.41) 100%)"
          padding={'2rem'}

        >
          {/* <Flex gap="2rem" textAlign="left" direction="column" border={'2px solid'} > */}

          <Flex style={smallTextStyle} direction={{ base: 'column', md: 'row' }} justifyContent={{ md: 'space-evenly' }} w={'60vw'} >

            <Flex direction={'column'} justify={'space-evenly'}>
              <Text mb={'1rem'} style={bigTextStyle}>Try SMS Flash Today</Text>
              <Text>
                Experience the power of SMS Flash firsthand. Request a demo
                <br />

                and discover how our SMPP Switch can transform your A2P
                <br />
                messaging infrastructure.</Text>
              <Button
                marginTop="2rem"
                fontFamily="Roboto"
                fontWeight="700"
                fontSize="16px"
                lineHeight="24px"
                color="rgba(255, 255, 255, 1)"
                bg="linear-gradient(84.6deg, #390EF7 0%, #9244F4 100.09%)"
                padding="16px, 40px, 16px, 40px"
                borderRadius="8px"
                w="174px"
                h="56px"

                _hover={{
                  bg: "linear-gradient(84.6deg, #390EF7 0%, #9244F4 100.09%)",
                }}
                onClick={openDemo}
              >
                Book a demo
              </Button>
              <BookDemoModal isOpen={isDemoOpen} onClose={closeDemo} />
            </Flex>


          </Flex>
          {/* <Flex border={'2px solid green'}> */}

          {/* </Flex> */}

          {/* </Flex> */}
          <Flex align={'center'}>
            <img src={chart} alt="Analytics chart visualization" style={{ height: '250px' }} />
          </Flex>

        </Flex>

        <ExploreServices />
      </Flex>
      <Review />
      <Faq />
      <Flex mb="3rem" justifyContent="center">
        <Flex
          justifyContent="center"
          bg="linear-gradient(148.13deg, rgba(57, 14, 247, 0.08) 16.69%, rgba(146, 68, 244, 0.08) 84.78%)"
          h="300px"
          w="85%"
          borderRadius="16px"
        >
          <Flex mt="2rem" alignItems="center" gap="1rem" direction="column">
            <img src={groupIcon} alt="Group collaboration icon" width="120px" height="56px" />
            <Text
              fontFamily="Inter"
              fontWeight="500"
              fontSize="20px"
              lineHeight="30px"
              color="rgba(16, 24, 40, 1)"
            >
              Still have questions?
            </Text>
            <Text
              fontFamily="Inter"
              fontWeight="400"
              fontSize="16px"
              lineHeight="28px"
              color="rgba(102, 112, 133, 1)"
            >
              Can’t find the answer you’re looking for? Feel free to connect with our friendly team.
            </Text>
            <Button
              onClick={openGetInTouch}
              borderRadius="8px"
              w="130px"
              h="44px"
              bg="linear-gradient(180deg, #390EF7 0%, #8C33FC 100%)"
              color="rgba(255, 255, 255, 1)"
              fontFamily="Inter"
              fontWeight="600"
              fontSize="16px"
              lineHeight="24px"
              _hover={{
                bg: "linear-gradient(180deg, #390EF7 0%, #8C33FC 100%)",
              }}
            >
              Get in touch
            </Button>
            <GetInTouchModal isOpen={isGetInTouch} onClose={closeGetInTouch} />
          </Flex>
        </Flex>
      </Flex>
      <Footer />
    </Box>
  );
}

export default LandingPage;
